require('./builders/conversation_builder.ts');
require('./builders/conversation_thread_builder.ts');
require('./commands/delete_conversation_thread_command.ts');
require('./commands/load_conversation_threads_command.ts');
require('./commands/load_conversations_command.ts');
require('./commands/update_conversation_status_command.ts');
require('./commands/update_conversation_thread_status_command.ts');
require('./components/conversation_card/conversation_card_controller.ts');
require('./components/conversation_filter/conversation_filter_controller.ts');
require('./components/conversation_list_content/conversation_list_content_controller.ts');
require('./components/conversation_thread_card/conversation_thread_card_controller.ts');
require('./components/conversation_threads_content/conversation_threads_content_controller.ts');
require('./configuration.ts');
require('./conversations_interface.ts');
require('./datasources/conversation_datasource.ts');
require('./datasources/conversation_thread_datasource.ts');
require('./queries/conversation_threads_query.ts');
require('./queries/conversations_priority_feed_query.ts');
require('./queries/conversations_query.ts');
require('./routes.ts');
require('./servants/conversation_thread_servant.ts');
require('./strategies/conversation_filter_strategy.ts');
require('./strategies/conversation_priority_feed_strategy.ts');
require('./types/conversation_thread_status_enum.ts');
require('./views/conversation_list/conversation_list_controller.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/core.ts